import isEqual from 'lodash/isEqual';
import type {Prize} from 'api/types';

/**
 * We remove winner id's before comparing prizes, because the id is removed on change.
 */
export const arePrizesEqual = (prize1: Prize, prize2: Prize): boolean => {
  return isEqual(cleanPrize(prize1), cleanPrize(prize2));
};

const cleanPrize = (prize: Prize): Prize => {
  return {
    ...prize,
    winners: (prize.winners ?? []).map(winner => ({
      ...winner,
      id: '',
    })),
  };
};
